import SearchTag from '@/common/search-tag-list';
import { acreToSqft } from '@/common/utils/acre-sqft';
import { OUT_FIELDS } from '../_util';

import { usePageStore } from '@/store';

function getSuggestionValue(valueArr) {
    return valueArr.reduce((memo, val) => {
        const [type, value] = val.split(':');
        memo[type] || (memo[type] = []);
        memo[type].push(value);
        return memo;
    }, {});
}

const processApiParams = {
    mapPath(searchData, mapCondition) {
        if (mapCondition.mapPath) {
            let mapPath = [];
            try {
                mapPath = JSON.parse(mapCondition.mapPath);
                if (mapPath && Array.isArray(mapPath)) {
                    searchData['location'] = {
                        mapPath: mapPath.map(o => JSON.stringify(o))
                    };
                }
            } catch (e) {
                console.error(e);
            }
          
        }
        return searchData;
    },
    mapRadius(searchData, mapCondition) {
        if (mapCondition.mapRadius) {
            searchData['location'] = {
                mapRadius: mapCondition.mapRadius
            };
        }
        return searchData;
    },
    keywords(searchData, state) {
        if (state.keywords.length) {
            const obj = state.keywords.reduce((acc, cur) => {
                acc[cur.keywordType] || (acc[cur.keywordType] = []);
                acc[cur.keywordType].push(cur.keyword);
                return acc;
            }, {});
            searchData['location'] = obj;
        }
        return searchData;
    },
    conditionArr(searchData, state) {
        const conditions = state.conditions;
        Object.entries(conditions).forEach(([name, o]) => {
            let { value, inputType } = o;
            if (name === 'location') {
                return; 
            }
            if (inputType === 'suggestion') {
                value = getSuggestionValue(value);
            }

            const ui = state.uiConfig[name];
            const { sqft } = ui || {};
            if (sqft === 'acre' && value) {
                const [v1, v2] = value.split(',');
                value = `${acreToSqft(v1)},${acreToSqft(v2)}`;
            }
            searchData[name] = value;
        });
        return searchData;
    }
};
const calcTagsCount = function(exclude = []) {
    const searchConfigMap = this.searchConfigMap;
    let allCondition = this.allConditions;
    allCondition = allCondition.reduce((memo, cur) => {
        if (exclude.includes(cur.dn)) {
            return memo; 
        }
        memo[cur.dn] = cur.values;
        return memo;
    }, {});
    let { page: globalData } = usePageStore(this.$pinia);
    const tag = new SearchTag(
        this,
        allCondition,
        globalData.siteId,
        searchConfigMap,
        globalData.currencyRate,
        globalData.currencySymbol,
        globalData.currencyAbbr === globalData.baseCurrency
    );
    return tag.getTagSync().length;
};

const getters = {
    moduleMap(state) {
        let configMap = {}
        if (state.fetcherData?.more) {
            for (let i = 0; i < state.fetcherData.more.length; i++) {
                let cfg = state.fetcherData.more[i];
                for (let j = 0; j < cfg.propertyConfigs.length; j++) {
                    let c = cfg.propertyConfigs[j];
                    configMap[c.kee] = c;
                }
            }
        }
        if (state.fetcherData?.propertyConfigs) {
            let cfg = state.fetcherData.propertyConfigs;
            for (let j = 0; j < cfg.length; j++) {
                let c = cfg[j];
                configMap[c.kee] = c;
            }
        }
        return configMap
    },
    mobileFilterCount(state) {
        let count = 0;
        Object.values(state.conditions).forEach(cond => {
            if (!OUT_FIELDS.includes(cond.kee)) {
                count += cond.labels.filter(label => !!label).length;
            }
        });
        return count;
    },
    allConditions(state) {
        let allConditions = [];
        let conditions = state.conditions;
        if (state.keywords.length) {
            let obj = {
                dn: 'key',
                split: ';',
                values: [],
                labels: []
            };
            state.keywords.forEach(keyword => {
                // keyword.keyword = decodeURIComponent(keyword.keyword)
                obj.values.push(keyword.keywordType + ':' + keyword.keyword);
                obj.labels.push(keyword.keyword);
            });
            allConditions.push(obj);
        }

        if (state.mapCondition.mapPath) {
            allConditions.push({
                dn: 'mapPath',
                values: [state.mapCondition.mapPath],
                labels: [
                    this.$t(
                        'md-search-bar:md-search-bar.customBoundary'
                    )
                ]
            });
        }
        if (state.mapCondition.mapRadius) {
            allConditions.push({
                dn: 'mapRadius',
                values: [state.mapCondition.mapRadius],
                labels: [
                    this.$t('md-search-bar:md-search-bar.mapRadius')
                ]
            });
        }
        if (state.mapCondition.mapSearch) {
            allConditions.push({
                dn: 'mapSearch',
                values: [true],
                labels: [
                    this.$t('md-search-bar:md-search-bar.mapArea')
                ],
                rect: state.mapCondition.rect
            });
        }
        Object.keys(conditions).forEach(key => {
            let item = conditions[key];
            if (!item.value) {
                return;
            }
            allConditions.push({
                dn: item.kee,
                values:
                    typeof item.value === 'string'
                        ? item.value.split(item.split || ',')
                        : [item.value],
                labels: item.labels
            });
        });
        return allConditions;
    },
    moreLen(state) {
        let len = 0;
        const conditions = state.conditions;
        Object.values(conditions).forEach(cond => {
            if (cond.inMore) {
                if (cond.type === 'tag-input') {
                    len += cond.value
                        .split(cond.split)
                        .filter(label => !!label).length;
                } else {
                    len += cond.labels.filter(label => !!label).length;
                }
            }
        });
        return len;
    },
    searchParamsGetter(state) {
        let params = {
            listingSource: state.listingSource
        };
        if (state.keywords.length) {
            const SPLIT = ';';
            params.key = state.keywords.map(obj => obj.keyword).join(SPLIT);
            params.keywordType = state.keywords
                .map(obj => obj.keywordType)
                .join(SPLIT);
        }
        Object.keys(state.conditions).forEach(kee => {
            let value = state.conditions[kee].value;
            if (!value) {
                return;
            }
            params[kee] = state.conditions[kee].value;
        });
        return params;
    },
    searchParamsWithMap(state) {
        const ret = { ...this.searchParamsGetter };
        if (state.mapCondition.mapPath) {
            ret.mapPath = state.mapCondition.mapPath;
        }
        if (state.mapCondition.mapSearch) {
            ret.mapSearch = state.mapCondition.mapSearch;
            ret.rect = state.mapCondition.rect;
        }
        if (state.mapCondition.mapRadius) {
            ret.mapRadius = state.mapCondition.mapRadius;
        }
        return ret;
    },
    filterCount(state) {
        let count = state.keywords.length;
        if (state.mapCondition.mapPath) {
            count++;
        }
        if (state.mapCondition.mapRadius) {
            count++;
        }
        Object.values(state.conditions).forEach(cond => {
            count += cond.labels.filter(label => !!label).length;
        });
        return count;
    }
};


const excludeCommon = [
    'location',
    'key',
    'mapPath',
    'mapRadius',
    'mapSearch'
];


const centerGetters = {
    searchConfigMap(state) {
        let configMap = {}
        if (state.fetcherData?.rawConf) {
            for (let i = 0; i < state.fetcherData.rawConf.length; i++) {
                let cfg = state.fetcherData.rawConf[i];
                for (let j = 0; j < cfg.conditions.length; j++) {
                    let c = cfg.conditions[j];
                    configMap[c.name] = { ...c, componentType: state.primaryKeysMap[c.name]?.componentType };
                }
            }
        }
        return configMap
    },
    allConditions(state) {
        let allConditions = [];
        let conditions = state.conditions;
        if (state.keywords.length) {
            let obj = {
                dn: 'key',
                split: ';',
                values: [],
                labels: [],
                aiRecommendList: [] // 每个keyword的aiRecommend状态
            };
            state.keywords.forEach(keyword => {
                // keyword.keyword = decodeURIComponent(keyword.keyword)
                obj.values.push(keyword.keywordType + ':' + keyword.keyword);
                obj.labels.push(keyword.keyword);
                obj.aiRecommendList.push(keyword.aiRecommend || false);
            });
            allConditions.push(obj);
        }
        if (state.mapCondition.mapPath) {
            allConditions.push({
                dn: 'mapPath',
                values: [state.mapCondition.mapPath],
                labels: [
                    this.$t(
                        'md-search-bar:md-search-bar.customBoundary'
                    )
                ]
            });
        }
        if (state.mapCondition.mapRadius) {
            allConditions.push({
                dn: 'mapRadius',
                values: [state.mapCondition.mapRadius],
                labels: [
                    this.$t('md-search-bar:md-search-bar.mapRadius')
                ]
            });
        }
        if (state.mapCondition.mapSearch) {
            allConditions.push({
                dn: 'mapSearch',
                values: [true],
                labels: [
                    this.$t('md-search-bar:md-search-bar.mapArea')
                ],
                rect: state.mapCondition.rect
            });
        }
        Object.entries(conditions).forEach(([name, o]) => {
            let values;
            if (o.inputType === 'suggestion') {
                values = getSuggestionValue(o.value);
            } else {
                values = o.value;
            }
            allConditions.push({
                dn: name,
                values,
                ...(o.aiRecommend && { aiRecommend: o.aiRecommend })
            });
        });
        return allConditions;
    },
    mobileFilterCount(state) {
        let count = 0;
        const exclude = [
            ...excludeCommon,
            ...state.outsideFields.slice(0, 3)
        ];
        count += calcTagsCount.call(this, exclude);
        return count;
    },
    showOutFields(state) { 
        let { outsideFields, hiddenOutFields } = state
        return outsideFields.filter(k => !hiddenOutFields.includes(k))
    },
    moreLen(state) {
        const exclude = [
            ...excludeCommon
        ];
        return calcTagsCount.call(this, exclude);
    },
    filterCount(state) {
        let count = state.keywords.length;
        if (state.mapCondition.mapPath) {
            count++;
        }
        if (state.mapCondition.mapRadius) {
            count++;
        }
        const exclude = [
            ...excludeCommon
        ];
        count += calcTagsCount.call(this, exclude);
        return count;
    },

    searchParamsGetter(state) {
        let params = {
            listingSource: state.listingSource
        };
        let searchData = {};
        const mapCondition = JSON.parse(JSON.stringify(state.mapCondition));
        if (state.keywords.length > 0) {
            searchData = processApiParams.keywords(searchData, state);
        } else if (mapCondition.mapPath) {
            searchData = processApiParams.mapPath(searchData, mapCondition);
        } else if (mapCondition.mapRadius) {
            searchData = processApiParams.mapRadius(searchData, mapCondition);
        }
        delete mapCondition.mapPath;
        delete mapCondition.mapRadius;
        searchData = processApiParams.conditionArr(searchData, state);
        params.condition = JSON.stringify(searchData);
        params.uiConfig = JSON.stringify(state.uiConfig || {});
        Object.assign(params, mapCondition);
        return params;
    },
    searchParamsWithMap(state) {
        const ret = { ...this.searchParamsGetter };
        if (!state.mapCondition.mapSearch) {
            delete ret.mapSearch;
            delete ret.rect;
        }
        delete ret.threshold;
        return ret;
    }
};

export default searchCenter => (searchCenter ? centerGetters : getters);
